import React from "react";
import Button from "components/button";
import { Pencil } from "assets/icons";

/** A summarised field: its value as saved, and the way back to the step that owns it. */
const SummaryField = ({ label, value, detail, editLabel, onEdit }) => (
    <div
        className={
            "flex justify-between items-center gap-4 py-3 border-b border-gray-100 last:border-b-0"
        }
    >
        <div className={"ft-sm text-gray-500 shrink-0"}>{label}</div>
        <div className={"flex items-center gap-3 min-w-0"}>
            <div className={"flex flex-col items-end min-w-0"}>
                <span className={"ft-sm text-gray-900 text-right break-words"}>
                    {value || "-"}
                </span>
                {detail ? (
                    <span
                        className={"ft-sm text-gray-500 text-right break-words"}
                    >
                        {detail}
                    </span>
                ) : null}
            </div>
            <Button color={"SECONDARY"} size={"ICON"} onClick={onEdit}>
                <span className={"sr-only"}>{editLabel}</span>
                <span aria-hidden="true">
                    <Pencil wh={16} color={"#374151"} />
                </span>
            </Button>
        </div>
    </div>
);

export default SummaryField;
